var map = {
	"./en/exchange.png": "QrX+",
	"./ja/exchange.png": "AmSz",
	"./ko/exchange.png": "RQej",
	"./zh-CN/exchange.png": "IJGQ",
	"./zh-TW/exchange.png": "+nMS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7Mzg";


//////////////////
// WEBPACK FOOTER
// ./static/images ^\.\/.*\/exchange\.png$
// module id = 7Mzg
// module chunks = 1